import { networkLabel } from "@/lib/network";
import { PLATFORM_NAME, PLATFORM_TAGLINE, ROUTES } from "@/lib/routes";
import { Link } from "react-router-dom";

/** Slim legal footer — Agent Layer band mounts below this row. */
export function SiteFooter() {
	const env = networkLabel();

	return (
		<footer className="border-t border-border/40 py-4">
			<div className="container mx-auto flex flex-wrap items-center justify-between gap-3 px-4 text-xs text-muted-foreground">
				<p className="flex flex-wrap items-center gap-2">
					<span>
						© 2026 {PLATFORM_NAME}. All rights reserved. · {PLATFORM_TAGLINE}
					</span>
					<span className="inline-flex items-center rounded-full border border-border bg-card px-2 py-0.5 font-mono text-[10px] uppercase tracking-wide">
						env · {env}
					</span>
				</p>
				<div className="flex flex-wrap gap-4">
					<Link to={ROUTES.docs} className="hover:text-foreground">
						Docs
					</Link>
					<Link to={ROUTES.governance} className="hover:text-foreground">
						Governance
					</Link>
					<Link to={ROUTES.more} className="hover:text-foreground">
						More
					</Link>
				</div>
				<p className="w-full text-[10px] leading-relaxed text-muted-foreground/80">
					{PLATFORM_NAME} is an ICP-native overcollateralized CDP (vault-minted
					USDM) — not an unbacked seigniorage stablecoin. Official UI is this IC
					assets canister (or verified custom domain). Ignore DMs / fake vote
					links — only sign MMK approvals here. Play Mode uses DEMO tokens only.
				</p>
			</div>
		</footer>
	);
}
